{
  "version": 1,
  "asset_id": "a62feb23-3d56-410f-9ad9-1871fd41ff79",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/a62feb23-3d56-410f-9ad9-1871fd41ff79/hiatal-type-1-es-v3-800.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/a62feb23-3d56-410f-9ad9-1871fd41ff79/hiatal-type-1-es-v3-800.jpg",
  "original_filename": "hiatal-type-1-es-v3-800.jpg",
  "size": 117447,
  "content_type": "image/jpeg",
  "created_at": "2026-10-28T23:09:10Z"
}
